(function () {
  const applyFormStyles = (shadowRoot) => {
    const sheet = new CSSStyleSheet();

    sheet.replaceSync(`
      /* Hide native radio and checkbox inputs */
      input[type="radio"],
      input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
      }

      /* Hide the checkbox box wrapper */
      div[class*="checkboxWrapper"] {
        display: none;
      }

      /* ===== RADIO BUTTONS ===== */
      label[class*="radioField"] {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px 20px;
        border: 1.6px solid #20202033;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        background: #fff;
        transition: background 0.15s, color 0.15s, border-color 0.15s;
      }

        label[class*="radioField"] span {
        color: #284946;

        }

      label[class*="radioField"]:hover {
        border: 1.6px solid #294946 !important;
        background: #284946;
      }

    label[class*="radioField"]:hover span{
        color: white;
      }

      label[class*="radioField"]:has(input:checked) {
        border: 1.6px solid #294946 !important;
        background: #284946;

      }
      label[class*="radioField"]:has(input:checked) span{
        color: white ;
      }

      /* Radio group: horizontal row */
      div[class*="verticalLayout"]:has(label[class*="radioField"]) {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
      }

      /* ===== CHECKBOXES ===== */
      label[class*="checkboxField"] {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 20px;
        border: 1.6px solid #20202033;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        background: #fff;
     
        transition: background 0.15s, color 0.15s, border-color 0.15s;
      }

       label[class*="checkboxField"] span {   
       color: #284946;
       }

      label[class*="checkboxField"]:hover {
       border: 1.6px solid #294946 !important;
       background: #284946;

      }
      label[class*="checkboxField"]:hover span {
        color: white;
      }

      label[class*="checkboxField"]:has(input:checked) {
      border: 1.6px solid #294946 !important;
      background: #284946;

      }

      label[class*="checkboxField"]:has(input:checked) span {
        color: white;
      }

      /* Checkbox group: 2-column grid */
      div[class*="verticalLayout"]:has(label[class*="checkboxField"]) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }
    `);

    shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
  };

  const init = () => {
    const host = document.querySelector('shopify-forms-embed#app-embed');
    if (!host || !host.shadowRoot) return false;
    applyFormStyles(host.shadowRoot);
    return true;
  };

  if (!init()) {
    const observer = new MutationObserver(() => {
      if (init()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();